import { digdirModule, NavItemModule } from 'src/components/AppHeader/types';
import { useAuth } from 'src/features/authorization';
import { ROUTES } from 'src/navigation';

export default function useNavItemModules() {
  const { checkAccess } = useAuth();

  const isSivaBusinessGarden = checkAccess('UI_SivaBusinessGarden').read;
  // Her lager vi modulene som skal i menyen
  // Indeksen i listen gjenspeiles i menyen
  const NavItemModules: NavItemModule[] = [
    {
      text: 'frontPage',
      path: '/',
      shortcut: 'F',
    },
    {
      module: 'OneWayIn',
      text: 'opportunities',
      path: ROUTES.ONE_WAY_IN.BASE,
      shortcut: 'H',
    },
    {
      module: 'ResourceBase',
      text: 'resourceBase',
      path: '/resource-base',
      shortcut: 'K',
    },
    {
      module: 'Operation',
      text: 'clusterOperation',
      path: '/cluster-operation',
    },
    {
      module: ['PortalProject', 'DevelopmentProject'],
      text: 'Projects',
      path: '/projects',
    },
    {
      module: 'Assignments',
      text: 'assignments',
      path: '/assignments',
      shortcut: 'O',
    },
    {
      module: 'Statistics',
      text: 'statistics',
      path: '/statistics',
    },
    {
      module: 'Financing',
      text: 'financing',
      path: '/financing',
    },
    {
      module: 'SivaCore',
      text: isSivaBusinessGarden ? 'targetedCompanies' : 'ideasAndCompanies',
      path: ROUTES.SIVA.IDEAS_AND_COMPANIES.BASE,
      shortcut: isSivaBusinessGarden ? 'M' : 'E',
    },
    {
      module: 'SivaCore',
      text: 'sivaReporting',
      path: ROUTES.SIVA.REPORTING.BASE,
      shortcut: 'R',
    },
    {
      module: 'SivaAdmin',
      text: 'sivaReporting',
      path: ROUTES.SIVA.ADMIN.BASE,
      shortcut: 'R',
    },
    {
      module: 'SivaAdmin',
      text: 'sivaDataExtract',
      path: ROUTES.SIVA.ADMIN.EXTRACT.BASE,
      shortcut: 'D',
    },
    {
      module: ['SivaCore', 'OneWayIn'],
      text: 'services',
      path: `/services`,
      shortcut: 'J',
    },
  ];

  // Her lager vi modulene som skal i menyen
  const digdirModules: digdirModule[] = [
    {
      module: ['SivaCore', 'OneWayIn'],
      linkGroup: {
        heading: { title: 'services.Header', url: '/services' },
        pages: [{ title: 'services', url: '/services' }],
      },
    },
    {
      module: 'OneWayIn',
      linkGroup: {
        heading: { title: 'opportunitiesHeader', url: ROUTES.ONE_WAY_IN.BASE },
        pages: [{ title: 'opportunities', url: ROUTES.ONE_WAY_IN.BASE }],
      },
    },
    {
      module: 'SivaCore',
      linkGroup: {
        heading: {
          title: 'ideasAndCompaniesHeader',
          url: ROUTES.SIVA.IDEAS_AND_COMPANIES.BASE,
        },
        pages: [
          {
            title: isSivaBusinessGarden ? 'targetedCompanies' : 'ideasAndCompanies',
            url: ROUTES.SIVA.IDEAS_AND_COMPANIES.BASE,
          },
        ],
      },
    },
    {
      module: 'SivaCore',
      linkGroup: {
        heading: {
          title: 'sivaReporting.Header',
          url: ROUTES.SIVA.REPORTING.BASE,
        },
        pages: [
          { title: 'sivaReporting.Budgets', url: ROUTES.SIVA.REPORTING.BUDGET },
          { title: 'sivaReporting.GoalNumber', url: ROUTES.SIVA.REPORTING.GOALS.BASE },
          { title: 'sivaReporting.AchievedGoals', url: ROUTES.SIVA.REPORTING.ACHIEVED.BASE },
          { title: 'sivaReporting.Spending', url: ROUTES.SIVA.REPORTING.FUNDS.BASE },
          { title: 'sivaReporting.SelfDeclaration', url: ROUTES.SIVA.REPORTING.DECLARATION.BASE },
        ],
      },
    },
  ];

  return { NavItemModules, digdirModules };
}
